<template>
  <div>
    <Hero titleStrong="Cutting edge research" title="to create new medicines" :imageUrl="Image"/>
    <Main/>
  </div>
</template>

<script>
import Image from '../assets/index.jpg';
import Hero from './Hero.vue'
import Main from './Main.vue'

export default {
  name: 'app',
  components: {
    Hero, Main
  },
  data() {
    return{
      Image
    }
  }
}
</script>